import React           from 'react';
import { Translate }   from 'react-localize-redux';
import styled, { css } from 'styled-components';
import ImgLeft         from './images/tips.png';
import Section         from './section';
import titleImg        from './images/title/Tips.png';

const Image = styled.img`
  margin-top: 1em;
  width: 100%; 
`;

/**
 * Tipsのセクション
 */
const Tips = () => {

  return (
    <>
      <Section imgSrc={titleImg} />
      <Image src={ImgLeft}  />
    </>
  );
};

export default Tips;
